module.exports = __webpack_public_path__ + "static/media/nboost.3ba222c0.svg";